export const webview = {
  webviewContent: 'Tai išorinis URL, kuris bus atidarytas naujame lange. Atidaryti?',
  webviewButtonOpenTitle: 'Atidaryti',
  webviewButtonCopyTitle: 'Kopijuoti URL',
  webviewButtonOpenAgainTitle: 'Atidaryti dar kartą',
  notifications: {
    urlCopied: 'URL nukopijuotas!'
  }
}
